<template>
	<section :class="['previewable-file-item', {open:previewerOpen}]">
		<div class="file__header">
            <div v-if="doCheckbox" class="header-checkbox">
                <v-checkbox
                        :height="10"
                        v-model="isChecked"
                        color="primary"
                />
            </div>
			<div :class="['header-icon',(doCheckbox) ? 'no-left-padding':'']">
				<img :src="getFileIconItem"/>
			</div>
			<div class="header-title">
				<v-tooltip v-if="doAbbreviatedFileName" top open-delay="400">
                    <h4 style="cursor:help"  slot="activator" >{{ abbreviatedFileName }}</h4>
                    <span class="grey--text text--lighten-3">{{ abbreviatedFileNameFullname }}</span>
                </v-tooltip>
                <h4 v-else >{{ abbreviatedFileNameFullname }}</h4>

				<div class="subheader">
					<p class="caption rev-ind"><span>{{ getFileUsageSubType }}</span> {{ getAttachmentAnnotation }}</p>
				</div>
			</div>
			<div class="header-actions">
				<div
					v-show="!editMode"
					class="none-edit-actions">

                    <v-tooltip
                            v-if="file.upload_status != $store.state.constants.SILA_FILE_UPLOAD_STATUS_SUCCESS"
                            top
                            open-delay="400"
                    >
                        <v-hover
                            slot="activator"
                            class="holder-download"
                            v-if="!itsAssetFile">
                                <v-btn

                                    icon small
                                    :disabled="file.upload_status != $store.state.constants.SILA_FILE_UPLOAD_STATUS_SUCCESS"
                                    slot-scope="{ hover }"
                                    ref="downloadBtn"
                                    @click="downloadAttachment">
                                        <v-icon :class="`${(hover) ? 'primary--text' : 'grey--text text--darken-1'} download-btn`">publish</v-icon>
                                </v-btn>

                        </v-hover>
                        <span class="grey--text text--lighten-3">Please check back after the file finishes uploading.</span>
                    </v-tooltip>
                    <v-hover
                            slot="activator"
                            class="holder-download"
                            v-else-if="!itsAssetFile">
                        <v-btn

                                icon small
                                :disabled="file.upload_status != $store.state.constants.SILA_FILE_UPLOAD_STATUS_SUCCESS"
                                slot-scope="{ hover }"
                                ref="downloadBtn"
                                @click="downloadAttachment">
                            <v-icon :class="`${(hover) ? 'primary--text' : 'grey--text text--darken-1'} download-btn`">publish</v-icon>
                        </v-btn>

                    </v-hover>

					<!-- PDF.JS FILE PREVIEW -->
					<v-hover
                        class="holder-preview-pdf"
						v-if="previewFile">
						<v-btn
							icon small
							slot-scope="{ hover }"
							@click="openPreviewerWindow">
							<v-icon :class="`${(hover) ? 'primary--text' : 'grey--text text--darken-1'} preview-btn`">{{getPreviewerIcon}}</v-icon>
						</v-btn>
					</v-hover>

					<!-- ITS FILE PREVIEW -->
					<v-hover
                        class="holder-preview-its"
						v-else-if="itsAssetFile">
						<v-btn
							icon small
							slot-scope="{ hover }"
							@click="openITSAssetWindow">
							<v-icon :class="`${(hover) ? 'primary--text' : 'grey--text text--darken-1'} preview-btn`">{{getPreviewerIcon}}</v-icon>
						</v-btn>
					</v-hover>
				</div>
				<div
					v-show="editMode && canRemove"
					class="edit-actions">
					<!-- <v-hover>
						<v-btn
							icon small
							slot-scope="{ hover }"
							:disabled="!showAction_Remove"
							@click="removeItem">
							<v-icon class="red--text text--darken-5 remove-btn">close</v-icon>
						</v-btn>
					</v-hover> -->

					<v-tooltip
						top
						open-delay="400">
						<v-icon
							slot="activator"
							size="16px"
							class="remove-btn"
							@click.stop="removeAttachment">
							cancel</v-icon>
						<span class="grey--text text--lighten-3">Remove</span>
					</v-tooltip>
				</div>
			</div>
		</div>
		<div class="file__previewer">
			<div class="previewer-border"/>
			<div class="previewer-inner">
				<template
					v-if="previewerOpen && previewFile">
					<sila-pdf-viewer
						:url="previewFile.uri"
						:id="previewFile.id"
						/>
				</template>
				<template v-else-if="previewerOpen && (thumbnailFile || itsAssetFile)">
					<img
						:src="thumbnailFile.uri || thumbnailFile"
						:id="thumbnailFile.id"
						@error="thumbLoadError"
						/>
				</template>
				<template v-else>
					<p>Could not load preview</p>
				</template>
			</div>
		</div>

        <div class="item-date">
            <v-tooltip top open-delay="400">
                <p class="timestamp" slot="activator">{{ timeAgo}}</p>
                <span class="grey--text text--lighten-3">
                    {{ file.created_at | f__twoDigitFullDate }}
                    {{ file.created_at | f__hourMinute }}
                </span>
            </v-tooltip>
        </div>

    </section>
</template>


<script>
	import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
    import getFileIcon from '@/helpers/getFileIcon'
    import dayjs from 'dayjs'
    import relativeTime from 'dayjs/plugin/relativeTime'

	import {
		VUEX_ATTACHMENTS_DELETE_ATTACHMENT
	} from '@/store/constants/attachments'
	import {
		VUEX_UI_SET_PREVIEW_OPEN_STATUS
	} from '@/store/constants/ui'


	import SILAPDFViewer from '@/components/ui/_global/viewer/SILA_PDF_Viewer'


	const previewableFileFilters = {
		previews: [
			SILA_FILE_USAGE_TYPE_JOB_ATTACHMENT_PREVIEW,
			SILA_FILE_USAGE_TYPE_ABSENCE_NOTICE_ATTACHMENT_PREVIEW,
			SILA_FILE_USAGE_TYPE_TIME_OFF_REQUEST_ATTACHMENT_PREVIEW,
			SILA_FILE_USAGE_TYPE_MEMO_ATTACHMENT_PREVIEW,
            SILA_FILE_USAGE_TYPE_JOB_PREMEDIA_ATTACHMENT_PREVIEW,
		],
		thumbnails: [
			SILA_FILE_USAGE_TYPE_JOB_ATTACHMENT_THUMBNAIL,
			SILA_FILE_USAGE_TYPE_MEMO_ATTACHMENT_THUMBNAIL,
		]
	}


	export default {
		name: 'previewable-file-item',
		props: {
			file: {
				type: Object,
				required: true
			},
			attachment: {
				type: Object,
				required: false
			},
			controls: {
				type: Array,
				required: false,
				default: (() => [])
			},
			canRemove: {
				type: Boolean,
				required: false,
				default: false
			},
			editMode: {
				type: Boolean,
				default: false
			},
			removeDispatchEvent: {
				type: [Function, Promise],
				required: false,
				default: null
			},
            doCheckbox: {
                type: Boolean,
                default: false
            },
		},

        data() {
            return {
                itemType:"previewable",
                previewerOpen: false,
                loadThumbError: false,
                isChecked:false
            }
        },

		components: {
			'sila-pdf-viewer': SILAPDFViewer
		},

		mounted() {
            if (this.openStatusList.hasOwnProperty(this.file.id) &&
                this.openStatusList[this.file.id] === true &&
                this.previewerOpen === false) {
                this.$nextTick(function () {
                    this.openPreviewerWindow()
                })
			}
		},

		computed: {
			...mapState({
				job: state => state.jobs.job,
				openStatusList: state => state.ui.previewOpenStatusList,
			}),

			...mapGetters({
				getJobEnumItemValueByKey: 'getJobEnumItemValueByKey',
				currentUserHasPerm: 'currentUserHasPerm',
				getCurrentUser: 'getCurrentUser'
			}),

            timeAgo() {
			    let time = this.file.created_at
                if(time) {
                    return dayjs().to(dayjs(time,'YYYY-MM-DD HH:mm:ss'))
                } else {
                    return ''
                }

            },

            //////////////////////////////////////////
            //Previewable_file_item && FTP_File_Item - IDENTICAL LOGIC BEGIN
            doAbbreviatedFileName() {
                let ret = this.file.name || this.file.filename
                let maxLength = 45
                let retLength = ret.length
                if (retLength > maxLength) {
                    return true
                } else {
                    return false
                }
            },
            abbreviatedFileNameFullname() {
                let ret = this.file.name || this.file.filename
                return ret
            },
            abbreviatedFileName() {
                let ret = this.abbreviatedFileNameFullname
                let retLength = ret.length
                if (this.doAbbreviatedFileName) {
                    ret = ret.substring(0, 20) + ' ... ' + ret.substring(retLength-20)
                }
                return ret
            },
            //Previewable_file_item && FTP_File_Item - IDENTICAL LOGIC END
            //////////////////////////////////////////




			getPreviewerIcon() {
				return (this.previewerOpen) ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
			},

			previewFile() {
                try {
                    if (this.file !== null && this.file.children !== null) {
                        let result = this.file.children.filter(child => {
                            if (previewableFileFilters.previews.indexOf(child.usage_type) > -1 &&
                                child.processing_status == SILA_FILE_PROCESSING_STATUS_SUCCESS) {
                                return true
                            }
                        })

                        if (result.length > 0) return result[0]
                    }
                } catch(error) {

                }
				return false
			},

			itsAssetFile() {
				if (!this.file.filemeta) return
				return (this.file.filemeta.its_result) ? this.file.filemeta.its_result : null
			},

			thumbnailFile() {
				// if load attemped and fail, load error is TRUE then show default
				if (this.loadThumbError)
					return require('@/assets/images/no-preview-available.jpg')

				let result = this.file.children.filter(child => {
					if (previewableFileFilters.thumbnails.indexOf(child.usage_type) > -1 &&
						child.processing_status == SILA_FILE_PROCESSING_STATUS_SUCCESS) {
						return true
					}
				})

				// if ITS asset
				if (this.file.filemeta.hasOwnProperty('its_result'))
					return this.file

				// if has children && can load
				if (result && !this.loadThumbError)
					return result[0]

				// otherwise FALSE
				return false
			},

            getFileIconItem() {
				return this.getFileIcon(this.file.filename)
			},

			getFileUsageSubType() {
				let sub_type = this.getJobEnumItemValueByKey('fileJobAttachmentSubtypes', this.file.usage_sub_type, 'value', 'name')
				if (sub_type) return sub_type

				switch(this.file.usage_type) {
					case SILA_FILE_USAGE_TYPE_ITS_ASSET :
					case SILA_FILE_USAGE_TYPE_ITS_PRODUCT :
						return this.getJobEnumItemValueByKey('fileJobAttachmentSubtypes', SILA_FILE_USAGE_SUB_TYPE__JOB_REFERENCE_ART, 'value', 'name')
						break

					// FTP has own component
					/*case SILA_FILE_USAGE_TYPE_FTP_URL :
						return 'FTP'
						break*/

					default :
						return ''
						break
				}
			},

			getAttachmentAnnotation() {
				return this.attachment ? this.attachment.note : ''
			},

			showAction_Remove() { return this.controls.includes('Remove') && this.file.upload_status == SILA_FILE_UPLOAD_STATUS_SUCCESS },
		},

		methods: {
			...mapActions({
				removeCommentAttachment: VUEX_ATTACHMENTS_DELETE_ATTACHMENT
			}),

            getFileIcon,

			...mapMutations({
				setPreviewOpenStatus: VUEX_UI_SET_PREVIEW_OPEN_STATUS
			}),

			openPreviewerWindow() {
				this.previewerOpen = !this.previewerOpen
				this.setPreviewOpenStatus({
					id: this.file.id,
					status: this.previewerOpen
				})
			},

			openITSAssetWindow () {
				this.previewerOpen = !this.previewerOpen

			},

			downloadAttachment(event) {
				let fileName = this.file.filename
				let fileLoc = this.file.uri
				let fileType = this.file.mimetype ? this.file.mimetype : 'image/*'

			  	let link = document.createElement("a")

				let fileRef = new Blob([fileLoc], { type:fileType })
			  	// link.href = (window.URL ? URL : webkitURL).createObjectURL(fileRef);
				link.href = fileLoc
				link.type = fileType
				link.download = fileName

				link.click()
				link.remove()
			},

			removeAttachment() {
				if (this.removeDispatchEvent) {
					this.removeDispatchEvent(this.attachment)
				} else {
					console.error("Previewable_File_Item -> removeAttachment(): You must pass a 'removeDispatchEvent' to remove the item.")
				}
			},

			thumbLoadError() {
				this.loadThumbError = true
			}
		}
	}
</script>
